"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.minuteBatteryInitialState = exports.getMinuteBatteryLoading = exports.getMinuteBatteryError = exports.getMinuteBattery = exports.fetchingMinuteBattery = exports.fetchMinuteBatterySuccess = exports.fetchMinuteBatteryIfNeeded = exports.fetchMinuteBatteryFailure = exports.fetchMinuteBattery = exports["default"] = exports.FETCH_MINUTE_BATTERY_SUCCESS = exports.FETCH_MINUTE_BATTERY_FAILURE = exports.FETCHING_MINUTE_BATTERY = void 0;

var _luxon = require("luxon");

var _immutable = require("immutable");

var _reselect = require("reselect");

var _Battery = require("../api/Battery");

var _timeseriesHelpers = require("./timeseriesHelpers");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var FETCH_MINUTE_BATTERY_SUCCESS = 'performance/FETCH_MINUTE_BATTERY_SUCCESS';
exports.FETCH_MINUTE_BATTERY_SUCCESS = FETCH_MINUTE_BATTERY_SUCCESS;
var FETCH_MINUTE_BATTERY_FAILURE = 'performance/FETCH_MINUTE_BATTERY_FAILURE';
exports.FETCH_MINUTE_BATTERY_FAILURE = FETCH_MINUTE_BATTERY_FAILURE;
var FETCHING_MINUTE_BATTERY = 'performance/FETCHING_MINUTE_BATTERY';
exports.FETCHING_MINUTE_BATTERY = FETCHING_MINUTE_BATTERY;

var fetchMinuteBatterySuccess = function fetchMinuteBatterySuccess(performance) {
  return {
    type: FETCH_MINUTE_BATTERY_SUCCESS,
    payload: performance
  };
};

exports.fetchMinuteBatterySuccess = fetchMinuteBatterySuccess;

var fetchMinuteBatteryFailure = function fetchMinuteBatteryFailure(err, prospectId, startDate, endDate) {
  return {
    type: FETCH_MINUTE_BATTERY_FAILURE,
    payload: {
      error: err,
      prospectId: prospectId,
      startDate: startDate,
      endDate: endDate
    }
  };
};

exports.fetchMinuteBatteryFailure = fetchMinuteBatteryFailure;

var fetchingMinuteBattery = function fetchingMinuteBattery(prospectId, startDate, endDate) {
  return {
    type: FETCHING_MINUTE_BATTERY,
    payload: {
      prospectId: prospectId,
      startDate: startDate,
      endDate: endDate,
      data: 'loading'
    }
  };
};

exports.fetchingMinuteBattery = fetchingMinuteBattery;

var fetchMinuteBattery = function fetchMinuteBattery(prospectId, startDate, endDate, baseUrl, authToken) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var _yield$ListBatteryMin, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(fetchingMinuteBattery(prospectId, startDate, endDate));
              _context.prev = 1;
              _context.next = 4;
              return (0, _Battery.ListBatteryMinute)(prospectId, startDate, endDate, baseUrl, authToken);

            case 4:
              _yield$ListBatteryMin = _context.sent;
              data = _yield$ListBatteryMin.data;
              dispatch(fetchMinuteBatterySuccess({
                data: data,
                prospectId: prospectId,
                startDate: startDate,
                endDate: endDate
              }));
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              dispatch(fetchMinuteBatteryFailure(_context.t0.message, prospectId, startDate, endDate));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.fetchMinuteBattery = fetchMinuteBattery;

var fetchMinuteBatteryIfNeeded = function fetchMinuteBatteryIfNeeded(prospectId, startDate, endDate, baseUrl, authToken) {
  return function (dispatch, getState) {
    var _getState = getState(),
        minuteBattery = _getState.minuteBattery;

    var loadingSet = (0, _timeseriesHelpers.getReading)(prospectId, startDate, endDate, minuteBattery, 'loading');

    if (loadingSet) {
      return null;
    }

    var luxonStart = _luxon.DateTime.fromISO(startDate);

    var luxonEnd = _luxon.DateTime.fromISO(endDate);

    var readings = minuteBattery.get('readings');
    var existing = readings.filter(function (reading) {
      return (0, _timeseriesHelpers.hasSameValues)(reading, prospectId, luxonStart, luxonEnd);
    });

    if (existing.size > 0) {
      return null;
    }

    return dispatch(fetchMinuteBattery(prospectId, startDate, endDate, baseUrl, authToken));
  };
};

exports.fetchMinuteBatteryIfNeeded = fetchMinuteBatteryIfNeeded;

var minuteBatterySelector = function minuteBatterySelector(state) {
  return state.minuteBattery;
};

var getMinuteBattery = function getMinuteBattery(prospectId, startDate, endDate) {
  return (0, _reselect.createSelector)([minuteBatterySelector], function (minuteBattery) {
    return (0, _timeseriesHelpers.getReading)(prospectId, startDate, endDate, minuteBattery, 'readings');
  });
};

exports.getMinuteBattery = getMinuteBattery;
var getMinuteBatteryLoading = (0, _reselect.createSelector)([minuteBatterySelector], function (performance) {
  return performance.get('loading').size > 0;
});
exports.getMinuteBatteryLoading = getMinuteBatteryLoading;
var getMinuteBatteryError = (0, _reselect.createSelector)([minuteBatterySelector], function (performance) {
  return performance.get('error');
});
exports.getMinuteBatteryError = getMinuteBatteryError;
var minuteBatteryInitialState = (0, _immutable.fromJS)({
  readings: [],
  error: null,
  loading: []
});
exports.minuteBatteryInitialState = minuteBatteryInitialState;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : minuteBatteryInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_MINUTE_BATTERY_SUCCESS:
      return (0, _timeseriesHelpers.onSuccess)(action, state, 'readings');

    case FETCH_MINUTE_BATTERY_FAILURE:
      return (0, _timeseriesHelpers.onFailure)(action, state);

    case FETCHING_MINUTE_BATTERY:
      return state.updateIn(['loading'], function (arr) {
        return arr.push(action.payload);
      });

    default:
      return state;
  }
};

exports["default"] = _default;